import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Kursant } from '../../services/kursant';
import { KursanciService } from '../../services/kursanci.service';

@Component({
  selector: 'app-kursant-details',
  templateUrl: './kursant-details.component.html',
  styleUrls: ['./kursant-details.component.scss']
})
export class KursantDetailsComponent {

    kursant: Kursant;

  constructor( 
      private route: ActivatedRoute, 
      private kursanciService: KursanciService ) 
    {
      route.data.subscribe(data => this.kursant = data['kursant']);
    }

    save(json) {

        this.kursanciService.zapiszKursanta(this.kursant.key, json)
            .subscribe(
                () => {
                    alert("Zapisano dane kursanta.");
                },
                err => alert(`Błąd zapisu danych. ${err}`)
            );

    }

}



// WEBPACK FOOTER //
// ./src/app/kursanci/kursant-details/kursant-details.component.ts